import Cursor, { CursorTypes } from 'editor/components/Cursor';
import DrawLineInteraction from 'editor/components/interactions/DrawLineInteraction';
import Markup from 'editor/components/Markup';
import Overlay from 'editor/components/Overlay';
import SheetEvents from 'editor/components/SheetEvents';
import ToolOverlay from 'editor/components/ToolOverlay';
import noop from 'lodash/noop';
import { MouseDownArgs, MouseMoveArgs, MouseUpArgs } from './index';

function mouseDown(args: MouseDownArgs): void {
  const { hit, markupKit, world } = args;
  const { MKMarkup } = markupKit;

  const markupComp = new Markup();
  const m = MKMarkup.createLine();
  const { x, y } = hit;

  m.setPoints([
    { x, y },
    { x, y },
  ]);

  m.setWidth(3);
  m.setFillOpacity(1);
  m.setFillColor(1, 0, 0);
  m.setStrokeColor(1, 0, 0);

  markupComp.mkMarkup = m;

  const toolOverlayEntity = world.locate([Overlay, ToolOverlay]);
  if (!toolOverlayEntity) return;

  const overlayComp = toolOverlayEntity.get(Overlay);

  world
    .createEntity()
    .add(overlayComp)
    .add(markupComp)
    .add(markupKit)
    .add(new DrawLineInteraction(x, y));

  world.grabAll(SheetEvents).forEach(({ component }) => {
    component.emit('drawline:mousedown', { markupComp });
  });
}

function mouseMove({ world, hit, markupKit }: MouseMoveArgs): void {
  // Should always be crosshair cursor for now.
  world.grabAll(Cursor).forEach(({ component }) => {
    component.cursor = CursorTypes.Crosshair;
  });

  const entity = world.locate(DrawLineInteraction);

  if (entity) {
    const m = world.get(entity.id, Markup);

    const point = new markupKit.MKPoint(hit.x, hit.y);

    m.mkMarkup?.setPoint(point, 1);
  }
}

function mouseUp({ hit, world }: MouseUpArgs): void {
  world.grabAll(DrawLineInteraction).forEach(({ entity, component }) => {
    if (hit.x !== component.originX && hit.y !== component.originY) {
      const m = world.get(entity.id, Markup);

      world.grabAll(SheetEvents).forEach(({ component }) => {
        component.emit('drawline:mouseup', { markupComp: m });
      });
    }
    entity.destroy();
  });
}

function dblclick(): void {
  // unimplemented
}

export default {
  mouseDown,
  mouseMove,
  mouseUp,
  click: noop,
  dblclick,
};
